import { render } from "./IndexRight.vue?vue&type=template&id=fa28f376"
import script from "./IndexRight.vue?vue&type=script&lang=js"
export * from "./IndexRight.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__